import React, {useEffect, useState} from 'react';
import ConfirmDialog from './ConfirmDialog';
import {registerConfirmHost} from '../actions/confirm';

export default function ConfirmDialogHost() {
    const [dialog, setDialog] = useState(null);

    useEffect(() => {
        registerConfirmHost((options) => {
            setDialog(options);
        });

        return () => registerConfirmHost(null);
    }, []);

    if (!dialog) {
        return null;
    }

    const handleClose = (isConfirmed) => {
        dialog.onResolve({isConfirmed});
        setDialog(null);
    };

    return (
        <ConfirmDialog
            open
            title={dialog.title}
            text={dialog.text}
            confirmButtonText={dialog.confirmButtonText}
            cancelButtonText={dialog.cancelButtonText}
            confirmButtonVariant={dialog.confirmButtonVariant}
            mode={dialog.mode}
            onConfirm={() => handleClose(true)}
            onCancel={() => handleClose(false)}
        />
    );
}
